import { GlKeysetPagination, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mapState, mapActions } from '../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { useDiffsView } from '../stores/diffs_view.js?vue3';
import { useFileBrowser } from '../../diffs/stores/file_browser.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'FileByFileNavigation',
    components: {
        GlKeysetPagination,
        GlSprintf
    },
    computed: {
        ...mapState(useDiffsView, [
            'singleFileMode',
            'currentFileNumber',
            'hasNextFile',
            'hasPrevFile'
        ]),
        ...mapState(useFileBrowser, [
            'flatBlobsList'
        ]),
        visible () {
            return this.singleFileMode && this.flatBlobsList.length > 1;
        },
        pageInfo () {
            return {
                hasPreviousPage: this.hasPrevFile,
                hasNextPage: this.hasNextFile
            };
        }
    },
    methods: {
        ...mapActions(useDiffsView, [
            'goToNextFile',
            'goToPrevFile'
        ])
    },
    i18n: {
        fileCount: __('File %{current} of %{total}')
    }
};
